// Search companies and products based on search term
export const searchCompanies = (items, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return items;
  }

  const term = searchTerm.toLowerCase().trim();
  
  return items.filter(item => {
    // Check if item matches search term
    return itemMatchesSearch(item, term);
  });
};

// Check if a single item matches the search term
export const itemMatchesSearch = (item, searchTerm) => {
  // Check item name
  if (item.name.toLowerCase().includes(searchTerm)) {
    return true;
  }

  // Check item description
  if (item.description && item.description.toLowerCase().includes(searchTerm)) {
    return true;
  }

  // Check company name for products
  if (item.company && item.company.toLowerCase().includes(searchTerm)) {
    return true;
  }

  // Check alternatives
  if (item.alternatives) {
    for (const alternative of item.alternatives) {
      if (alternative.name.toLowerCase().includes(searchTerm)) {
        return true;
      }
    }
  }

  // Check alternative companies
  if (item.alternativeCompanies) {
    for (const altCompany of item.alternativeCompanies) {
      if (altCompany.name.toLowerCase().includes(searchTerm)) {
        return true;
      }
    }
  }

  return false;
};

// Highlight search terms in text (for future use)
export const highlightSearchTerm = (text, searchTerm) => {
  if (!searchTerm || !text) return text;
  
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  return text.replace(regex, '<mark>$1</mark>');
};

// Get search result counts
export const getSearchResultCounts = (items, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    // Return total counts
    const companies = items.filter(item => item.type === 'company');
    const products = items.filter(item => item.type === 'product');
    const alternatives = items.reduce((total, item) => {
      if (item.alternatives) {
        total += item.alternatives.length;
      }
      if (item.alternativeCompanies) {
        total += item.alternativeCompanies.length;
      }
      return total;
    }, 0);

    return {
      companies: companies.length,
      products: products.length,
      alternatives: alternatives
    };
  }

  // Return filtered counts
  const filteredItems = searchCompanies(items, searchTerm);
  const companies = filteredItems.filter(item => item.type === 'company');
  const products = filteredItems.filter(item => item.type === 'product');
  const alternatives = filteredItems.reduce((total, item) => {
    if (item.alternatives) {
      total += item.alternatives.length;
    }
    if (item.alternativeCompanies) {
      total += item.alternativeCompanies.length;
    }
    return total;
  }, 0);

  return {
    companies: companies.length,
    products: products.length,
    alternatives: alternatives
  };
};
